import { render, staticRenderFns } from "./TheDeliveryFields.vue?vue&type=template&id=6c941752&scoped=true&"
import script from "./TheDeliveryFields.vue?vue&type=script&lang=ts&"
export * from "./TheDeliveryFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c941752",
  null
  
)

export default component.exports